var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"notification"}},[(_vm.show)?_c('div',{class:{'s': _vm.type === 's' || _vm.type === '', 'w': _vm.type === 'w', 'd': _vm.type === 'd'},attrs:{"id":"notification"}},[_c('div',{staticClass:"icon-container"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }